import styled from '@emotion/styled';
import { colors } from 'inpock-ui-react/dist/src/color';
import { Paragraph2 } from 'inpock-ui-react';

import IconSelect from '@/assets/icons/icon-menu-arrow.svg';
import IconInfo from '@/assets/icons/icon-info.svg';

export const Title = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 7px;
`;

export const QuantitySelectorContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const StyledSelect = styled.select`
  appearance: none;
  padding: 6px 18px 5px 11px;
  border-radius: 6px;
  border: 1px solid ${colors.gray200};
  background-color: ${colors.gray100};
  width: 100%;

  &::-ms-expand {
    display: none;
  }
`;

export const SelectArrow = styled.div`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-42%);
  width: 16px;
  height: 16px;
  background-image: url(${IconSelect});
  background-size: 16px 16px;
  background-repeat: no-repeat;
  pointer-events: none;
`;

export const Callout = styled.div`
  border-radius: 8px;
  padding: 12px;
  background-color: ${colors.gray100};
  margin-bottom: 20px;

  @media (max-width: 600px) {
    margin: 0 12px;
  }

  .callout-title {
    font-weight: 700 !important;
    margin-bottom: 6px;
  }

  li {
    position: relative;
    padding-left: 12px;
    font-family: 'Apple SD Gothic Neo';
    letter-spacing: -0.42px;

    &:not(:last-child) {
      margin-bottom: 6px;
    }
  }

  li::before {
    content: '・';
    font-size: 12px;
    position: absolute;
    left: 0;
    top: 4px;
    line-height: 1;
    color: ${colors.gray600};
  }
`;

export const AmountContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Step1OrderlineContainer = styled.div`
  display: flex;
  gap: 15px;

  &:not(:first-of-type) {
    margin-top: 20px;
  }

  .quantity-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
  }
`;

export const InlineParagraph2 = styled(Paragraph2)`
  display: inline;
  color: ${colors.gray700} !important;
`;

export const RefundInfo = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const IconWrapper = styled.div`
  position: relative;
`;

export const InfoIcon = styled.div`
  position: relative;
  background-image: url(${IconInfo});
  background-size: cover;
  width: 16px;
  height: 16px;
  cursor: pointer;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
`;

export const ModalFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Tooltip = styled.div<{ position?: [number, number] }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: absolute;
  top: 24px;
  left: ${({ position }) => (position ? `${position[0]}px` : '-44px')};

  z-index: 1000;
  background-color: ${colors.gray700};
  backdrop-filter: blur(1px);
  color: white;
  padding: 7px 8px;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: flex-start;

  span {
    width: 100%;
  }

  &::before {
    border-bottom: 8px solid ${colors.gray700};
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    content: '';
    height: 0;
    left: ${({ position }) => (position ? `${position[1]}px` : '44px')};
    position: absolute;
    top: -8px;
    transform: scaleX(10px);
    width: 0;
  }
`;

export const OrderGroupContainer = styled.div`
  display: flex;
  gap: 10px;
`;
